import { ConfigHeader } from "../../types/config";
import {
  appleIcon,
  facebookIcon,
  googlePlaystoreIcon,
  instagramIcon,
  pinterestIcon,
  tiktokIcon,
} from "./icons/socialIcon";

export const configHeader: ConfigHeader = {
  megaMenu: {
    newsletter: {
      text: "Get exclusive weekly updates to Singapore's design scene, trend scoops, shopping and interior styling tips with our newsletter now.",
      buttonText: "SIGN UP",
      url: "/newsletter-signup",
    },
    closeButton: {
      type: "icon",
      placement: "right",
    },
    divider: {
      footer: false,
    },
  },
  socialMedia: {
    target: "_blank",
    icons: [
      {
        icon: appleIcon,
        name: "iOS App Store",
        href: "https://apps.apple.com/sg/app/home-decor-singapore/id537207561",
      },
      {
        icon: googlePlaystoreIcon,
        name: "Google Playstore",
        href: "https://play.google.com/store/apps/details?id=com.magzter.homeanddecorsingapore",
      },
      {
        icon: instagramIcon,
        name: "Instagram",
        href: "https://instagram.com/homeanddecor_sg/",
      },
      {
        icon: facebookIcon,
        name: "Facebook",
        href: "https://www.facebook.com/HomeandDecor.Singapore",
      },
      {
        icon: tiktokIcon,
        name: "Tiktok",
        href: "https://www.tiktok.com/@homeanddecor.sg",
      },
      {
        icon: pinterestIcon,
        name: "Pinterest",
        href: "https://www.pinterest.com/homeanddecorsg/",
      },
    ],
  },
};

export const hamburgermenuSvgSource = (
  <svg
    width="33"
    height="22"
    viewBox="0 0 33 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.09961 13.7559H31.6648"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1.09961 21H31.6648"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M31.7627 6.95652L16.3814 2L1 6.95652"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
